import React from 'react';
import { connect } from 'react-redux';
import {
  loadIpmaCisCreator,
  setIpmaCisPageCreator,
  setIpmaCisPerPageCreator,
  setIpmaCisSortCreator,
  setIpmaCisFiltersCreator,
  removeIpmaCisFiltersCreator,
  setIpmaCisProfileCreator,
  loadGlobalCisCertificatesAttributesCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import { removeIpmaCisCreator } from '../../../../store/actionsCreators';
import Certificates from '../../../../shared/Cis/Certificates/Certificates';

const mapStateToProps = ({ loading, ipma, globals }) => ({
  loading: isLoading(loading, 'LOAD_IPMA_CIS'),
  type: 'ipma-cvmb',
  list: ipma.cis.certificates,
  countries: globals.countries,
  certificationBodies: globals.cis.certificationBodies,
  levelDomains: globals.cis.levelDomains,
  levelDomainsLevels: globals.cis.levelDomainsLevels,
  levelDomainsDomains: globals.cis.levelDomainsDomains,
  organizations: globals.cis.organizations,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadIpmaCisCreator('certificates')),
  setPage: (payload) => dispatch(setIpmaCisPageCreator('certificates', payload)),
  setPerPage: (payload) => dispatch(setIpmaCisPerPageCreator('certificates', payload)),
  setSort: (payload) => dispatch(setIpmaCisSortCreator('certificates', payload)),
  setFilters: (payload) => dispatch(setIpmaCisFiltersCreator('certificates', payload)),
  removeFilters: () => dispatch(removeIpmaCisFiltersCreator('certificates')),
  setProfile: (payload) => dispatch(setIpmaCisProfileCreator('certificates', payload)),
  removeCertificate: (payload) => dispatch(removeIpmaCisCreator('certificates', payload)),
  loadCertificatesAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Certificates); 